<kt-portlet>
  <!-- PORTLET LOADING | Binded to TABLE Datasource -->
  <!-- See prop => '~/core/_crud/models/data-sources/_base.datasource.ts' (loading$) -->
  <kt-portlet-header [title]="'Users list'">
    <ng-container ktPortletTools>
      <div class="search-title" data-mdb-input-init style="display: flex !important">
        <input placeholder="Search in all fields" type="search" id="form1" class="form-control" (keyup)="applyFilter($event.target.value)" style="border-left: 1px solid #dddada !important; background-color: #f9f9f9" />
        <button type="button" class="btn btn-primary" data-mdb-ripple-init style="width: 63px !important">
          <i class="fas fa-search"></i>
        </button>
      </div>

      <div>
        <label>{{ userName }} </label>

        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

        <button [routerLink]="['../users/add']" mat-raised-button color="primary" matTooltip="Create new User">New user</button>
      </div>
      <!-- Buttons (Material Angular) | See off.documenations 'https://material.angular.io/components/button/overview' -->
      <!-- mat-raised-button | Rectangular contained button w/ elevation  -->
    </ng-container>
  </kt-portlet-header>
  <!-- end::Header -->

  <!-- start::Body (attribute: ktPortletBody) -->
  <kt-portlet-body>
    <!-- start::FILTERS & GROUP ACTIONS -->
    <div class="form kt-margin-b-30">
      <!-- start::FILTERS -->
      <div class="form-filtration">
        <div class="row align-items-center" style="display: none">
          <div class="col-md-2 kt-margin-bottom-10-mobile">
            <mat-form-field class="mat-form-field-fluid">
              <input matInput placeholder="Search user" #searchInput placeholder="Search" />
              <mat-hint align="start"> <strong>Search</strong> in all fields </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- end::FILTERS -->

      <!-- start::GROUP ACTIONS -->
      <!-- Group actions list: 'Delete selected' | 'Fetch selected' | 'Update status for selected' -->
      <!-- Group actions are shared for all LISTS -->
      <div class="row align-items-center collapse form-group-actions kt-margin-top-20 kt-margin-bottom-20" [ngClass]="{ show: selection.selected.length > 0 }">
        <!-- We show 'Group Actions' div if smth are selected -->
        <div class="col-xl-12">
          <div class="form-group form-group-inline">
            <div class="form-label form-label-no-wrap">
              <label class="font-bold font-danger-"> <span translate="ECOMMERCE.COMMON.SELECTED_RECORDS_COUNT"></span> {{ selection.selected.length }} </label>
              <!-- selectedCountsTitle => function from codeBehind (users-list.component.ts file) -->
              <!-- selectedCountsTitle => just returns title of selected items count -->
              <!-- for example: Selected records count: 4 -->
            </div>
            <div>
              <button (click)="fetchUsers()" mat-raised-button matTooltip="Fetch selected users" class="mat-button-mt-4">
                <mat-icon>clear_all</mat-icon>
                Fetch Selected
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- end::GROUP ACTIONS -->
    </div>
    <mat-form-field appearance="outline" class="me-2" id="customFilter" style="width: 15%">
      <mat-label>Filter by Status</mat-label>
      <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusFilterChange($event.value)">
        <mat-option value="all">All</mat-option>
        <mat-option value="online">Online</mat-option>
        <mat-option value="offline">Offline</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- end::FILTERS & GROUP ACTIONS -->

    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
    <div class="mat-table__wrapper">
      <mat-table class="lmat-elevation-z8" #table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="id" matSortDirection="asc" matSortDisableClear>
        <!-- Checkbox Column -->

        <!-- Table with selection -->
        <!-- https://run.stackblitz.com/api/angular/v1?file=app%2Ftable-selection-example.ts -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="mat-column-checkbox">
            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"> </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="mat-column-checkbox">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"> </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
          <!-- ATTRIBUTE mat-sort-header  for sorting | https://material.angular.io/components/sort/overview -->
          <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ user.id }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="fullname">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Full name</mat-header-cell>
          <mat-cell *matCellDef="let user">
            <div class="user-picture-container">
              <!-- User Picture -->
              <div class="user-picture-wrapper">
                <img class="user-picture" [src]="user.profilePicture" alt="User Picture" (error)="handleImageError(user)" />
              </div>

              <!-- Dot indicating user activity -->
              <div class="activity-dot" [ngClass]="{ 'active-dot': user.isActive, 'inactive-dot': !user.isActive }"></div>
            </div>
            <div style="padding-left: 6px">{{ user.fullname }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="username">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Username</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ user.username }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="email-cell">Email</mat-header-cell>
          <mat-cell *matCellDef="let user" class="email-cell">
            <a href="user-management/users#" class="font-weight-bold">{{ user.email }}</a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="role">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Roles</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ user.role }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>

          <mat-cell *matCellDef="let user">
            <div *ngIf="role === 'admin' || role === 'superadmin'">
              <button (click)="editUser(user.uuid)" mat-icon-button color="primary" matTooltip="Edit user">
                <mat-icon>create</mat-icon></button
              >&nbsp;
              <button mat-icon-button color="warn" matTooltip="Delete user" type="button" (click)="deleteUser(user)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <!--<div class="mat-table__message" *ngIf="!dataSource.hasItems">No records found</div>-->
      <!--<div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">Please wait....</div>-->
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table__bottom">
      <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
      <!--<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>--->
      <!-- MATERIAL PAGINATOR | Binded to dasources -->
      <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[3, 5, 10]" [length]="10" [showFirstLastButtons]="true"></mat-paginator>
    </div>
    <!-- end: BOTTOM -->
  </kt-portlet-body>
  <!-- end::Body -->
</kt-portlet>
